



































import { defineComponent } from "@vue/composition-api";
import AiResults from "../ai-results/AiResults.vue";
import AiAnswer from "./ai-answer/AiAnswer.vue";
import AiGenerateAnswerButton from "./ai-answer/AiGenerateAnswerButton.vue";
import { AiCacheSearchResultItem } from "@/types/ai/aiSearch";

export default defineComponent({
    name: "AiSearchResults",
    props: {
        // the same props as AiResult component, because this is a wrapper component
        items: Array as () => AiCacheSearchResultItem[],
        itemsToShow: Number,
        searchScope: String,
        allItemsLoaded: Boolean,
        showMoreAmount: Number,
        searchText: String,
        portalId: Number,
        //additional props
        isAllowedToGenerateAiAnswer: Function
    },
    components: {
        AiResults,
        AiAnswer,
        AiGenerateAnswerButton
    },
    setup(props, { emit }) {
        const handleGenerateAnswer = (item: AiCacheSearchResultItem) => {
            if (!props.isAllowedToGenerateAiAnswer(item)) return;
            emit("generate-ai-answer", item.content_item_id, props.searchScope);
        };

        return {
            handleGenerateAnswer
        };
    }
});
